type Props = {
  plan: string;
  customerNumber: string;
};

/**
 * 契約プラン名と契約番号を対で表示する共通テーブル部品。
 * 複数画面で同じ見せ方を揃え、契約識別情報の確認位置を統一するために切り出している。
 */
const Plan = ({ plan, customerNumber }: Props) => {
  return (
    <div className='m-table'>
      <table>
        <colgroup>
          <col />
          <col />
        </colgroup>
        <tbody>
          {/* 契約内容と契約番号を同じ表で並べ、問い合わせ時に必要な識別情報を一目で確認できるようにする。 */}
          <tr>
            <th className='m-table__th'>プラン</th>
            <td className='m-table__td'>{plan}</td>
          </tr>
          {/* 契約番号はサポート導線で頻出するため、プラン情報のすぐ下へ固定配置する。 */}
          <tr>
            <th className='m-table__th'>ご契約番号</th>
            <td className='m-table__td'>{customerNumber}</td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};

export default Plan;
